<template>
  <header class="fixed top-0 left-0 right-0 backdrop-blur-sm border-b z-50" 
          :class="isDark ? 'bg-gray-900/95 border-gray-800' : 'bg-white/95 border-gray-200'">
    <nav class="max-w-6xl mx-auto px-6 py-4">
      <div class="flex items-center justify-between">
        <router-link to="/" class="text-xl font-bold flex items-center space-x-2" 
           :class="isDark ? 'text-green-400' : 'text-green-600'">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
          </svg>
          <span>panzhijie.cn</span>
        </router-link>
        <div class="hidden md:flex items-center space-x-8">
          <router-link v-for="item in navItems" :key="item.path" :to="item.path" 
             class="text-sm font-medium transition-colors duration-300"
             :class="[
               isDark ? 'text-gray-300 hover:text-green-400' : 'text-gray-600 hover:text-green-600',
               ($route.path === item.path) ? (isDark ? 'text-green-400' : 'text-green-600') : ''
             ]">
            {{ item.label }}
          </router-link>
        </div>
        <div class="flex items-center space-x-4">
          <button @click="toggleTheme" 
                  class="p-2 rounded-lg transition-colors"
                  :class="isDark ? 'text-gray-400 hover:bg-gray-800' : 'text-gray-500 hover:bg-gray-100'">
            <svg v-if="!isDark" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </button>
          <div v-if="!isLoggedIn" class="hidden md:block">
            <button @click="$emit('openAuth')" 
                    class="px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium rounded-lg transition-colors">
              登录/注册
            </button>
          </div>
          <div v-else class="hidden md:flex items-center space-x-2">
            <div class="w-8 h-8 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center">
              <span class="text-white text-sm font-medium">{{ user?.name?.charAt(0) || 'U' }}</span>
            </div>
            <span class="text-sm font-medium" :class="isDark ? 'text-gray-300' : 'text-gray-700'">{{ user?.name }}</span>
            <button @click="handleLogout" 
                    class="px-3 py-1 text-sm rounded-lg transition-colors"
                    :class="isDark ? 'text-gray-400 hover:bg-gray-800' : 'text-gray-500 hover:bg-gray-100'">
              退出
            </button>
          </div>
          <button @click="toggleMenu" 
                  class="md:hidden transition-colors"
                  :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      <div v-show="menuOpen" class="md:hidden mt-4 pb-4 border-t pt-4 space-y-1"
           :class="isDark ? 'border-gray-800' : 'border-gray-200'">
        <router-link v-for="item in navItems" :key="item.path" :to="item.path" 
           class="block px-4 py-3 rounded-lg transition-colors"
           :class="[
             isDark ? 'text-gray-300 hover:bg-gray-800' : 'text-gray-600 hover:bg-gray-100',
             ($route.path === item.path) ? (isDark ? 'text-green-400 bg-green-500/20' : 'text-green-600 bg-green-50') : ''
           ]"
           @click="menuOpen = false">
          {{ item.label }}
        </router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import { useTheme } from '../composables/useTheme'
import { useAuth } from '../composables/useAuth'

export default {
  name: 'Header',
  emits: ['openAuth'],
  setup() {
    const { isDark, toggleTheme } = useTheme()
    const { user, isLoggedIn, logout } = useAuth()
    
    const handleLogout = () => {
      logout()
    }
    
    return { isDark, toggleTheme, user, isLoggedIn, handleLogout }
  },
  data() {
    return {
      menuOpen: false,
      navItems: [
        { label: '首页', path: '/' },
        { label: '博客', path: '/blog' },
        { label: '工具', path: '/tools' },
        { label: '关于', path: '/about' }
      ]
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    }
  }
}
</script>
